import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';

@Injectable({ providedIn: 'root' })
export class SellosFirmasService {

  private readonly base = '/settings/stamps-signatures';

  constructor(private api: ApiService) {}

  listarUsuarios(): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/users/list`, {});
  }

  obtenerConfiguracion(usuarioId: number): Observable<{ row: any }> {
    return this.api.post(`${this.base}/user/find`, { usuarioId });
  }

  guardarConfiguracion(usuarioId: number, datos: {
    sello_url?: string | null;
    firma_p12_url?: string | null;
    clave_p12?: string;
    datos_adicionales?: string | null;
  }): Observable<{ usuarioId: number }> {
    return this.api.post(`${this.base}/user/save`, { usuarioId, ...datos });
  }

  uploadFile(base64: string, filename: string, mimeType: string): Observable<{ url: string }> {
    return this.api.post(`${this.base}/upload-file`, { base64, filename, mimeType });
  }

}
